/* eslint-disable better-mutation/no-mutation */

import { createSlice } from '@reduxjs/toolkit';

export type OutageMessages = {
    heading: Record<string, string>;
    text: Record<string, string>;
    type: Record<string, string>;
    webpageURL: Record<string, string>;
};

type OutageState = {
    messages: OutageMessages[];
};

export const initialState: OutageState = {
    messages: []
};

const slice = createSlice({
    name: 'outage',
    initialState,
    reducers: {
        setMessages: (state, { payload }) => {
            state.messages = payload ?? [];
        }
    }
});

export const { setMessages } = slice.actions;
export const reducer = slice.reducer;
